export default "__VITE_ASSET__Cs2WoqE4__"